module.exports = __webpack_public_path__ + "media/images/official/special_migration_04-6248c3bed4a6e5b6c8cc57e89f3d8c39.jpg";